import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Button } from '../Button/Button';
import { _FormFieldBase } from './utils/formFieldBase';
export var formButtonClassName = 'ui-form__button';
/**
 * An FormButton renders a Button wrapped by FormField.
 */

export var FormButton = /*#__PURE__*/function () {
  var FormButton = compose(_FormFieldBase, {
    className: formButtonClassName,
    displayName: 'FormButton',
    overrideStyles: true,
    slots: {
      control: Button
    }
  });
  FormButton.propTypes = commonPropTypes.createCommon({
    content: false,
    // Should be `true`, but will be passed via unhandled props to a Button
    children: false
  });
  return FormButton;
}();